<script module lang="ts">
	import type { BackgroundPaint } from "#lib/components/flow/viewer/utils.js";

	const HOST_BACKGROUND_STYLE = "background-color: var(--background-color); background-image: var(--background-image); background-position: var(--background-position); background-repeat: var(--background-repeat); background-size: var(--background-size); background-attachment: var(--background-attachment);";
	// A fixed attachment anchors to the browser viewport, which is the wrong box inside a letterboxed card.
	const HOST_BACKGROUND_UNPINNED_STYLE = "background-color: var(--background-color); background-image: var(--background-image); background-position: var(--background-position); background-repeat: var(--background-repeat); background-size: var(--background-size); background-attachment: scroll;";
	const HOST_COLOR_STYLE = "background-color: var(--background-color);";

	export function hostBackgroundStyle(paint: BackgroundPaint): string {
		switch (paint) {
			case "none":
				return "";
			case "layer":
				return HOST_COLOR_STYLE;
			case "unpinned":
				return HOST_BACKGROUND_UNPINNED_STYLE;
			default:
				return HOST_BACKGROUND_STYLE;
		}
	}
</script>

<!--
	Sticky rather than background-attachment fixed, which iOS Safari resolves against a stale viewport box.
	overflow-clip must not become overflow-hidden, which would become the sticky scrollport and stop the
	layer sticking. -z-10 only paints above the host background when the host is a stacking context, so
	every host rendering this also sets isolate. Both var fallbacks reproduce the content box paint.
-->
<div aria-hidden="true" class="pointer-events-none absolute inset-0 -z-10 overflow-clip" style="border-radius: inherit;">
	<div class="w-full" style="position: var(--background-pin, static); top: 0; height: var(--background-layer-height, 100%); background-image: var(--background-image); background-position: var(--background-position); background-repeat: var(--background-repeat); background-size: var(--background-size); background-attachment: scroll;"></div>
</div>
